import debounce from "lodash/debounce";

export const createDebouncedFunction = <T extends (...args: unknown[]) => void>(
  fn: T,
  delay: number
) => debounce(fn, delay);
